import { useMutation } from "@tanstack/react-query";
import importFileService from "../api/importFileService";

export const useImportTasks = () => {
  const { importTasks } = importFileService();

  return useMutation({
    mutationKey: ["import-tasks"],
    mutationFn: async ({ boardId, file }) => {
      const response = await importTasks({ boardId, file });
      return response.data;
    },
  });
};

export const useImportTemplates = () => {
  const { importTemplates } = importFileService();

  return useMutation({
    mutationKey: ["import-templates"],
    mutationFn: async ({ taskTypeId, file }) => {
      const response = await importTemplates({ taskTypeId, file });
      return response.data;
    },
  });
};
